<!-- PrimeNG v19+: use value + panel/header/content (activeIndex / p-accordionTab are not used). -->
<p-accordion
    [value]="props?.attributes?.activeIndex ?? props?.attributes?.isOpen ?? 0"
    [ngStyle]="{ 'border': 'none', 'border-radius': '0' }"
>
    <p-accordion-panel [value]="0">
        <p-accordion-header>{{ props?.label }}</p-accordion-header>
        <p-accordion-content>
            <ng-container #fieldComponent></ng-container>
        </p-accordion-content>
    </p-accordion-panel>
</p-accordion>
